import React from 'react';
import axios from "axios"
import {
    observable,
    computed,
    action,
    autorun
} from "mobx";
import {
    Redirect
} from 'react-router-dom'
import {
    DownloadBlobToPdf
} from "../../assets/utils/DownloadManager";

class InfoStore {

    constructor (rootStore) {
        this.rootStore = rootStore
        this.service = rootStore.service
    }

    @observable value = undefined
    @observable review = false
    @observable conferma = false
    @observable RadioButton = '1'
    @observable ErrorMessage = false;
    @observable ErrorMessage2 = false;
    @observable RedirectTo = null;
    @observable datiAnagrafica = {};
    @observable fetched = false;
    @observable denominazione = '';
    @observable sigla = '';
    @observable descrizione = '';
    @observable sitoWeb = '';
    @observable CF = '';
    @observable Stato = '';
    @observable Email = '';
    @observable confermaEmail = '';
    @observable sede = '';
    @observable citta = '';
    @observable cap = '';
    @observable statoAttivita = '';
    @observable vat = '';
    @observable issuedCountry = '';
    @observable Information = [{
        azcng8A_CN_TITLE_EL: '',
        azcng8A_CN_FIRST_NAME_EL: '',
        azcng8A_CN_MIDDLE_NAME_EL: '',
        azcng8A_CN_LAST_NAME_EL: '',
        azcng8A_CN_STATO_NASC_EL: '',
        azcng8A_CN_DATA_NASC_EL: '',
        azcng8A_CN_SEX_EL: '',
        azcng8A_CN_PHONE_NUM_EL: '',
        azcng8A_CN_EMAIL_EL: '',
        azcng8A_CN_RELATIONSHIP_EL: ''
    }];
    @observable firstName = '';
    @observable lastName = '';
    @observable dateBirth = '';
    @observable gender = '';
    @observable countryBirth = '';
    @observable captcha = '';
    @observable src = {};
    @observable error = false;
    @observable listCheck = [];

    //MESSAGGI DI ERRORE
    @observable ErrorMessageText = '';
    @observable ErrorMessageText1 = '';
    @observable ErrorMessageText2 = '';
    @observable ErrorMessageText3 = '';
    @observable ErrorMessageText7 = '';
    @observable ErrorMessageText8 = '';
    @observable ErrorMessageText9 = '';
    @observable ErrorMessageText10 = '';
    @observable ErrorMessageText11 = '';
    @observable ErrorMessageText12 = '';
    @observable ErrorMessageText13 = '';
    @observable ErrorMessageText14 = '';
    @observable ErrorMessageText15 = '';
    @observable ErrorMessageText16 = '';
    @observable ErrorMessageText17 = '';
    @observable ErrorMessageText18 = '';
    @observable ErrorMessageText19 = '';
    @observable ErrorMessageText20 = '';
    @observable ErrorMessageTextInvia = '';
    @observable ErrorMessageTextDate = '';

    @observable ErrorDate_ = false;
    @observable ErrorTelefono = false;
    @observable ErrorEmail = false;
    @observable ErrorEmail2 = false;
    @observable ErrorNome = false;
    @observable ErrorCognome = false;
    @observable ErrorWebsite = false;
    @observable ErrorCompany = false;
    @observable ErrorDescription = false;
    @observable ErrorAddress = false;
    @observable ErrorCity = false;
    @observable ErrorStato = false;
    @observable ErrorDate = false;
    @observable ErrorCountryBirth = false;
    @observable ErrorEmail3 = false;
    @observable ErrorEmail4 = false;
    @observable ErrorRelationship = false;
    @observable ErrorMessageInvia = false;
    @observable datiConferma;
    @observable img;
    @observable audio;
    @observable captchaLoaded = false;
    @observable captchaState = { value: "", src: { img: "", audio: "" } }

    readBlob (blob) {
        let reader = new FileReader();
        reader.readAsDataURL(blob);
        return new Promise((resolve, reject) => {
          reader.onloadend = () => {
            resolve(reader.result);
          };
        });
      }
    fetchImage () {
    const config = {
        method: "GET",
        responseType: "blob",
        url: "/Api-OssRegRichIdServizi/jaxrs/captcha?type=img&lang=en",
        headers: {},
    };

    const request = axios(config);

    return request;
    }

    fetchAudio () {
    const config = {
        method: "GET",
        responseType: "blob",
        url: "/Api-OssRegRichIdServizi/jaxrs/captcha?type=audio&lang=en",
        headers: {},
    };

    const request = axios(config);

    return request;
    }

    @action fetchCaptcha(){
        this.fetchImage().then((response) => {
            this.readBlob(response.data).then((img) => {
              this.fetchAudio().then((response) => {
                this.readBlob(response.data).then((audio) => {
      
                  this.captchaState = { value: "", src: { img: img, audio: audio } }
                });
              });
            });
          });
    }

    @action controlFormObl () {
        if (this.denominazione === '' || this.descrizione === '' || this.CF === '' || this.stato === '' || this.sitoWeb === '' || this.Email === '' || this.confermaEmail === '' || this.sede === '' || this.citta === '' || this.statoAttivita === '') {
            this.ErrorMessageText20 = 'Enter all required fields';
            this.error = true;
        } else if (this.Email !== this.confermaEmail ) { 
            this.ErrorMessageText20 = 'Please enter the same e-mail';
            this.error = true;
        } else {
            this.ErrorMessageText20 = '';
            this.error = false;
        }
    }

    @action controlFormOblContact () {
        let azcng8A_CN_TITLE_EL = ''
        let azcng8A_CN_FIRST_NAME_EL = ''
        let azcng8A_CN_MIDDLE_NAME_EL = ''
        let azcng8A_CN_LAST_NAME_EL = ''
        let azcng8A_CN_STATO_NASC_EL = ''
        let azcng8A_CN_DATA_NASC_EL = ''
        let azcng8A_CN_SEX_EL = ''
        let azcng8A_CN_PHONE_NUM_EL = ''
        let azcng8A_CN_EMAIL_EL = ''
        let azcng8A_CN_RELATIONSHIP_EL = ''

        this.Information.map(el => {
            /* if (el.azcng8A_CN_TITLE_EL !== '') {
                azcng8A_CN_TITLE_EL = el.azcng8A_CN_TITLE_EL
            } */
            if (el.azcng8A_CN_FIRST_NAME_EL !== '') {
                azcng8A_CN_FIRST_NAME_EL = el.azcng8A_CN_FIRST_NAME_EL
            }
            if (el.azcng8A_CN_MIDDLE_NAME_EL !== '') {
                azcng8A_CN_MIDDLE_NAME_EL = el.azcng8A_CN_MIDDLE_NAME_EL
            }
            if (el.azcng8A_CN_LAST_NAME_EL !== '') {
                azcng8A_CN_LAST_NAME_EL = el.azcng8A_CN_LAST_NAME_EL
            }
            if (el.azcng8A_CN_STATO_NASC_EL !== '') {
                azcng8A_CN_STATO_NASC_EL = el.azcng8A_CN_STATO_NASC_EL
            }
            if (el.azcng8A_CN_DATA_NASC_EL !== '') {
                azcng8A_CN_DATA_NASC_EL = el.azcng8A_CN_DATA_NASC_EL
            }
            if (el.azcng8A_CN_SEX_EL !== '') {
                azcng8A_CN_SEX_EL = el.azcng8A_CN_SEX_EL
            }
            if (el.azcng8A_CN_PHONE_NUM_EL !== '') {
                azcng8A_CN_PHONE_NUM_EL = el.azcng8A_CN_PHONE_NUM_EL
            }
            if (el.azcng8A_CN_EMAIL_EL !== '') {
                azcng8A_CN_EMAIL_EL = el.azcng8A_CN_EMAIL_EL
            }
            if (el.azcng8A_CN_RELATIONSHIP_EL !== '') {
                azcng8A_CN_RELATIONSHIP_EL = el.azcng8A_CN_RELATIONSHIP_EL
            }
        })
        if (azcng8A_CN_FIRST_NAME_EL === '' || azcng8A_CN_LAST_NAME_EL === '' || azcng8A_CN_STATO_NASC_EL === '' || azcng8A_CN_DATA_NASC_EL === '' ||
            azcng8A_CN_SEX_EL === '' || azcng8A_CN_PHONE_NUM_EL === '' || azcng8A_CN_EMAIL_EL === '' || azcng8A_CN_RELATIONSHIP_EL === '' /* || azcng8A_CN_TITLE_EL === '' */) {
            this.ErrorMessageText20 = 'Enter all required fields';
        } else {
            this.ErrorMessageText20 = '';
        }

        if (this.ErrorMessageText20 === '') {
            this.controlFormObl();
        }
    }

    @action handleControlRadio () {

        if (this.RadioButton === undefined) {
            this.ErrorMessage2 = true;
            this.ErrorMessageText8 = 'Please choose one of the 2 options';
        } else {
            this.ErrorMessageText8 = '';
        }
    }

    @action handleControlCheck (list) {

        if (list.length == 0) {
            this.ErrorMessage2 = true;
            this.ErrorMessageText8 = 'Please choose at least one option';
        } else {
            this.ErrorMessageText8 = '';
        }
    }

    @action ChangeValueRedirectTo (url) {
        this.RedirectTo = url;
    }

    @action getRedirect () {
        return <Redirect to={
            this.RedirectTo
        }
            push={
                true
            }
        />;
    }

    @action validateNumberTel (value) {
        if (value == '') {
            this.ErrorMessageText = 'Field is required';
            this.ErrorTelefono = true;
        } else if (!/^[+]*[1-9][0-9]*([.][0-9]{2}|)$/.test(value)) {
            this.ErrorMessageText = 'Enter a valid phone number preceded by +39';
            this.ErrorTelefono = true;
        } else this.ErrorTelefono = false;
    }
    @action validateEmail (value) {

        if (value == '') {
            this.ErrorMessageText1 = 'Field is required';
            this.ErrorEmail = true;
        } else if (!/^[-0-9a-z.+_]+@[-0-9a-z.+_]+.[a-z]{2,20}$/.test(value)) {
            this.ErrorMessageText1 = 'Enter a valid e-mail address';
            this.ErrorEmail = true;
        } else this.ErrorEmail = false;
    }
    @action validateConfirmEmail (value) {
        if (value == '') {
            this.ErrorMessageText9 = 'Field is required';
            this.ErrorEmail2 = true;
        } else if (!/^[-0-9a-z.+_]+@[-0-9a-z.+_]+.[a-z]{2,20}$/.test(value)) {
            this.ErrorMessageText9 = 'Enter a valid e-mail address';
            this.ErrorEmail2 = true;
        } else {
            this.ErrorEmail2 = false;
        }
        if (this.Email === value) {
            this.ErrorMessageText9 = ''
            this.ErrorEmail2 = false;
        } else {
            this.ErrorMessageText9 = 'Please enter the same e-mail'
            this.ErrorEmail2 = true;
        }
    }
    @action validateNome (value) {
        if (value == '') {
            this.ErrorMessageText2 = 'Field is required';
            this.ErrorNome = true;
        } else this.ErrorNome = false;
    }
    @action validateCognome (value) {
        if (value == '') {
            this.ErrorMessageText3 = 'Field is required';
            this.ErrorCognome = true;
        } else this.ErrorCognome = false;
    }
    @action validateCompany (value) {
        if (value == '') {
            this.ErrorMessageText10 = 'Field is required';
            this.ErrorCompany = true;
        } else this.ErrorCompany = false;
    }
    @action validateDescription (value) {
        if (value == '') {
            this.ErrorMessageText11 = 'Field is required';
            this.ErrorDescription = true;
        } else this.ErrorDescription = false;
    }
    @action validateAddress (value) {
        if (value == '') {
            this.ErrorMessageText12 = 'Field is required';
            this.ErrorAddress = true;
        } else this.ErrorAddress = false;
    }
    @action validateCity (value) {
        if (value == '') {
            this.ErrorMessageText13 = 'Field is required';
            this.ErrorCity = true;
        } else this.ErrorCity = false;
    }
    @action validateStato (value) {
        if (value == '') {
            this.ErrorMessageText14 = 'Field is required';
            this.ErrorStato = true;
        } else this.ErrorStato = false;
    }
    @action validateDate (value) {
        if (value == '') {
            this.ErrorMessageText15 = 'Field is required';
            this.ErrorDate = true;
        } else this.ErrorDate = false;
    }
    @action validateCountryBirth (value) {
        if (value == '') {
            this.ErrorMessageText16 = 'Field is required';
            this.ErrorCountryBirth = true;
        } else this.ErrorCountryBirth = false;
    }

    @action validateEmail2 (value) {
        if (value == '') {
            this.ErrorMessageText17 = 'Field is required';
            this.ErrorEmail3 = true;
        } else if (!/^[-0-9a-zA-Z.+_]+@[-0-9a-zA-Z.+_]+.[a-zA-Z]{2,20}$/.test(value)) {
            this.ErrorMessageText17 = 'Enter a valid e-mail address';
            this.ErrorEmail3 = true;
        } else this.ErrorEmail3 = false;
    }

    @action validateConfirmEmail2 (value) {
        if (value == '') {
            this.ErrorMessageText18 = 'Field is required';
            this.ErrorEmail4 = true;
        } else if (!/^[-0-9a-z.+_]+@[-0-9a-z.+_]+.[a-z]{2,20}$/.test(value)) {
            this.ErrorMessageText18 = 'Enter a valid e-mail address';
            this.ErrorEmail4 = true;
        } else {
            this.ErrorEmail4 = false;
        }
        if (this.Information[0].azcng8A_CN_EMAIL_EL === value) {
            this.ErrorMessageText18 = ''
        } else {
            this.ErrorMessageText18 = 'Please enter the same e-mail'
        }
    }

    @action validateRelationship (value) {
        if (value == '') {
            this.ErrorMessageText19 = 'Field is required';
            this.ErrorRelationship = true;
        } else this.ErrorRelationship = false;
    }

    @action validateWebsite (value) {
        if (value == '') {
            this.ErrorMessageText7 = 'Field is required';
            this.ErrorWebsite = true;
        } else if (!/^(http:\/\/www\.|https:\/\/www\.|http:\/\/|https:\/\/)?[-wW0-9@:%._\+~#=]{1,3}\.[a-zA-Z0-9()]{1,100}\b([-a-zA-Z0-9()@:%_\+.~#?&//=]*)/.test(value)) {
            this.ErrorMessageText7 = 'Enter a valid site address';
            this.ErrorWebsite = true;
        } else this.ErrorWebsite = false;
    }

    @action handleInvia () {
        let dati = {
            //azcng8A_TIPO_RICH: this.RadioButton ? this.RadioButton : '',
            azcng8A_TIPO_RICH1: this.listCheck.find(x=>x=='1') != undefined ? '1' : '0',
            azcng8A_TIPO_RICH2: this.listCheck.find(x=>x=='2') != undefined ? '1' : '0',
            azcng8A_TIPO_RICH3: this.listCheck.find(x=>x=='3') != undefined ? '1' : '0',
            // valori non utilizzati ma predisposti da 4 a 5
            azcng8A_TIPO_RICH4: this.listCheck.find(x=>x=='4') != undefined ? '1' : '0',
            azcng8A_TIPO_RICH5: this.listCheck.find(x=>x=='5') != undefined ? '1' : '0',
            
            azcng8A_COMPANY_NAME: this.denominazione ? this.denominazione : '',
            azcng8A_TRADING_NAME: this.sigla ? this.sigla : '',
            azcng8A_VAT_NUMBER_ISS: this.issuedCountry ? this.issuedCountry : '',
            azcng8A_VAT_NUMBER: this.vat ? this.vat : '',
            azcng8A_NAT_TAX_REF_ISS: this.stato ? this.stato : '',
            azcng8A_NAT_TAX_REF: this.CF ? this.CF : '',
            azcng8A_DES_BUSINESS: this.descrizione ? this.descrizione : '',
            azcng8A_DICH_ASSENZA_UE: "1",
            azcng8A_WEB_SITE: this.sitoWeb ? this.sitoWeb : '',
            azcng8A_EMAIL: this.Email ? this.Email : '',
            azcng8A_INDIR: this.sede ? this.sede : '',
            azcng8A_CAP: this.cap ? this.cap : '',
            azcng8A_CITTA: this.citta ? this.citta : '',
            azcng8A_COUNTRY: this.statoAttivita ? this.statoAttivita : '',
            azcng8A_DESCR_STATO: "AQ",
            azcng8A_IC_FLAG: (this.firstName !== '' && this.lastName !== '' && this.dateBirth !== '' && this.countryBirth !== '' && this.gender !== '') ? '1' : '2',
            azcng8A_IC_FIRST_NAME: this.firstName ? this.firstName : '',
            azcng8A_IC_LAST_NAME: this.lastName ? this.lastName : '',
            azcng8A_IC_STATO_NASC: this.countryBirth ? this.countryBirth : '',
            azcng8A_IC_DATA_NASC: this.dateBirth ? this.dateBirth : '',
            azcng8A_IC_SEX: this.gender ? this.gender : '',
            azcng8A_CONTACT: this.Information ? this.Information : ''
        }
        console.log('dati ', dati)
        this.callSercviceInputInvia(dati);
    }

    @action callSercviceInputInvia (dati) {
        let url = `/sign-oss/getRichiestaIdentificativo?input-captcha=${ this.rootStore.infoStore.captcha }`
        let datiRisposta = this.service.doAjax(`${ process.env.METHOD_ }`, url, dati);
        this.rootStore.uiStore.isLoading = true;
        Promise.all([datiRisposta]).then(([dati]) => {
            if (dati && dati.success) {
                if (dati.result.azcng8A_COD_RIT !== "00") {
                    this.ErrorMessageTextInvia = dati.result.azcng8A_TESTO_ERR + " " + (dati.result.azcng8A_TESTO1_ERR != null ? dati.result.azcng8A_TESTO1_ERR : '');
                    this.ErrorMessageInvia = true;
                    this.fetchCaptcha()
                } else {
                    this.datiConferma = dati.result
                    this.RedirectTo = `${ process.env.CONTEXT_PATH }/esito`;
                }
            } else {
                this.rootStore.uiStore.isLoading = false;
                this.ErrorMessageTextInvia = "Something went wrong, the request could not be sent";
                this.ErrorMessageInvia = true;
            }
            this.rootStore.uiStore.isLoading = false;
        });
    }

    @action handleStampaRiepilogo = (denominazione, sede, cap, citta, statoAttivita, prot, dtProt, Information, CF, Stato, vat, issuedCountry) => {
        const dati = { "companyName": denominazione, "street": sede, "postcode": cap, "city": citta, "country": statoAttivita, 
                    "protTelem": prot, "dtProt": dtProt, "contatto": Information, "ntr": CF , "ntrIss" : Stato, "vatId" : vat, "vatIdIss" : issuedCountry}

        const company = { "companyName": denominazione }

        let dataFilePdf = this.service.doAjaxPDF("POST", `/sign-oss${ process.env.DATI_REGISTRAZIONE }`, dati /* company */);

        this.rootStore.uiStore.isLoading = true
        Promise.all([dataFilePdf]).then(([dati]) => {
            if (dati) {
                let fileName = `ReceiptRequest ${ JSON.stringify(new Date()) }.pdf`;
                DownloadBlobToPdf(dati.result, fileName);
            } else {
                this.fetched = false;
                this.rootStore.uiStore.isLoading = false;
                this.ErrorMessageText = "Cannot download the pdf file";
                this.ErrorMessage = true;
            }
            this.rootStore.uiStore.isLoading = false;
            this.fetched = true;
        });
    }

}


export default InfoStore;